import { render, staticRenderFns } from "./PropuestaHistorica.vue?vue&type=template&id=43f21f3f&scoped=true"
import script from "./PropuestaHistorica.vue?vue&type=script&lang=js"
export * from "./PropuestaHistorica.vue?vue&type=script&lang=js"
import style0 from "./PropuestaHistorica.vue?vue&type=style&index=0&id=43f21f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f21f3f",
  null
  
)

export default component.exports